'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Fieldset = require('../../../../components/form/Fieldset');

var _Fieldset2 = _interopRequireDefault(_Fieldset);

var _LinkButton = require('../../../../components/buttons/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _FormButton = require('../../../../components/form/FormButton');

var _FormButton2 = _interopRequireDefault(_FormButton);

var _FormInput = require('../../../../components/form/fields/FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _Spinner = require('../../../../components/loaders/Spinner');

var _Spinner2 = _interopRequireDefault(_Spinner);

var _paymentUtil = require('../../../../../common/payment/paymentUtil');

require('./CouponCode.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Coupon = function Coupon(_ref) {
    var coupon = _ref.coupon,
        values = _ref.values,
        dispatchClearCoupon = _ref.dispatchClearCoupon;

    if (!coupon) return null;

    return _react2.default.createElement(
        'div',
        { className: 'Coupon' },
        'Coupon:',
        ' ',
        _react2.default.createElement(
            'span',
            { className: 'code' },
            _react2.default.createElement(
                'strong',
                null,
                coupon.get('id')
            ),
            ' (',
            (0, _paymentUtil.describeCoupon)(coupon.toJS()),
            ')'
        ),
        ' ',
        _react2.default.createElement(
            _LinkButton2.default,
            { onClickFn: dispatchClearCoupon, className: 'show-field-button' },
            'Change'
        )
    );
};

Coupon.propTypes = {
    coupon: _propTypes2.default.object,
    values: _propTypes2.default.object,
    dispatchClearCoupon: _propTypes2.default.func
};

var CouponSubmitButton = function CouponSubmitButton(_ref2) {
    var fetching = _ref2.fetching,
        onClickFn = _ref2.onClickFn;
    return fetching ? _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_Spinner2.default, { show: true })
    ) : _react2.default.createElement(
        _FormButton2.default,
        {
            className: 'secondary',
            type: 'button',
            onClickFn: onClickFn },
        'Add coupon'
    );
};

CouponSubmitButton.propTypes = {
    fetching: _propTypes2.default.bool,
    onClickFn: _propTypes2.default.func
};

var CouponCode = function CouponCode(props) {
    var coupon = props.coupon,
        dispatchClearCoupon = props.dispatchClearCoupon,
        handleCouponButtonClick = props.handleCouponButtonClick;


    if (coupon && coupon.get('id') && !coupon.get('error')) {
        return _react2.default.createElement(Coupon, props);
    }

    var showField = coupon && (coupon.get('visible') || coupon.get('fetching') || coupon.get('error'));

    if (!showField) {
        return _react2.default.createElement(
            _Fieldset2.default,
            { name: 'CouponCode' },
            _react2.default.createElement(
                _LinkButton2.default,
                { onClickFn: dispatchClearCoupon, className: 'show-field-button' },
                'Have a coupon code?'
            )
        );
    }

    return _react2.default.createElement(
        _Fieldset2.default,
        { name: 'CouponCode' },
        _react2.default.createElement(
            'div',
            { className: 'form-row' },
            _react2.default.createElement(
                'div',
                { className: 'field-info' },
                _react2.default.createElement(
                    'label',
                    { className: 'field-label', htmlFor: 'coupon' },
                    'Coupon code'
                ),
                coupon && coupon.get('error') ? _react2.default.createElement(
                    'div',
                    { className: 'field-message error' },
                    'Sorry, coupon not valid'
                ) : null
            ),
            _react2.default.createElement(
                'div',
                { className: 'field-row' },
                _react2.default.createElement(
                    'div',
                    { className: 'field' },
                    _react2.default.createElement(_FormInput2.default, _extends({}, props, {
                        type: 'text',
                        name: 'coupon' }))
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'field-button' },
                    _react2.default.createElement(CouponSubmitButton, {
                        fetching: coupon && coupon.get('fetching'),
                        onClickFn: handleCouponButtonClick })
                )
            )
        )
    );
};

CouponCode.propTypes = {
    coupon: _propTypes2.default.object,
    dispatchClearCoupon: _propTypes2.default.func,
    handleCouponButtonClick: _propTypes2.default.func
};

exports.default = CouponCode;


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/payment/form/CouponCode.js
// module id = 2058
// module chunks = 0